import { FormPage, Skeleton } from '@skylabs-digital/backoffice-kit';
import { useParams } from 'react-router-dom';

import { templatesApi } from '../api/templates.api';
import { isManagedByCac } from '../components/shared/ManagedByCac';
import { TemplateForm } from '../components/templates/TemplateForm';

export function TemplateEditPage() {
  const { id } = useParams<{ id: string }>();
  const isEditing = Boolean(id);

  return (
    <FormPage
      title={isEditing ? 'Edit template' : 'Create template'}
      description={
        isEditing
          ? 'Update content for this event type and channel.'
          : 'Define the rendered content for an event type and channel.'
      }
      breadcrumbs={[
        { label: 'Templates', to: '/templates' },
        { label: isEditing ? 'Edit' : 'New' },
      ]}
      maxWidth={920}
    >
      {isEditing ? <EditingTemplate id={id as string} /> : <TemplateForm isEditing={false} />}
    </FormPage>
  );
}

function EditingTemplate({ id }: { id: string }) {
  const { data: template, loading, error } = templatesApi.useById(id);

  if (loading) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-64 w-full" />
        <Skeleton className="h-12 w-32" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="rounded-lg border border-destructive/40 bg-destructive/5 p-4 text-sm text-destructive">
        {error instanceof Error ? error.message : 'Failed to load template.'}
      </div>
    );
  }

  return <TemplateForm template={template} isEditing locked={isManagedByCac(template)} />;
}
